import { useSelector } from "react-redux"
import { selectColorMode } from "../../redux/slices/themeSlice"
import useLocalStorage from "./useLocalStorage";

export const useDarkMode = () => {
    const colorMode = useSelector(selectColorMode);
    // const [colorMode, setColorMode] = useLocalStorage('color-theme', 'light')
    return colorMode === 'dark';
}